import styled from '@emotion/styled'
import { css } from '@emotion/react'

const textShareStyles = ({ theme }) => css`
  label: modal__text-share;

  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${theme.spacings.mega};
  color: ${theme.colors.o500};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  line-height: 14px;

  span {
    margin-left: ${theme.spacings.byte};
  }

  svg {
    display: block;
    width: 12px;
    height: 12px;
  }

  ${theme.media.mega} {
    display: none;
  }
`

const descriptionStyles = ({ theme, heading }) => css`
  label: modal__info-description;

  display: block;

  color: ${heading ? theme.colors.black : theme.colors.n500};
  font-size: 13px;
  font-weight: ${heading ? theme.font.weight.semibold : theme.font.weight.regular};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  &:not(:last-child) {
    margin-bottom: ${heading
      ? `${theme.spacings.byte}`
      : `${theme.spacings.tera}`};
  }
`

export const TextShare = styled('span')(textShareStyles)
export const Description = styled('span')(descriptionStyles)
